export enum EBoxModel {
  trafficDetectorUrbanStandardFast = 'traffic-detector-urban-standard-fast',
  trafficDetectorUrbanStandardLarge = 'traffic-detector-urban-standard-large',
  trafficDetectorUrbanFisheyeFast = 'traffic-detector-urban-fisheye-fast',
  personDetectorDemoStandardFast = 'person-detector-demo-standard-fast',
  headDetectorRetailStandard = 'head-detector-retail-standard'
}
